// AI Marketing Command Center Translations - v3.0 //

export interface TranslationSet {
  sidebar: {
    plataforma: string;
    gestao: string;
    suporte: string;
    dashboard: string;
    optimizer: string;
    copywriter: string;
    landing_pages: string;
    quantum: string;
    integrations: string;
    reports: string;
    networking: string;
    subscription: string;
    domain: string;
    settings: string;
    terms: string;
    privacy: string;
    guide: string;
    contact: string;
    system: string;
    synchronized: string;
    simulateClient: string;
    clientActive: string;
    freePlan: string;
    trialPlan: string;
    adminPlan: string;
    daysRemaining: string;
    accessPremium: string;
  };
  dashboard: {
    title: string;
    subtitle: string;
    launchButton: string;
    setupDomainButton: string;
    guideButton: string;
    howItWorksButton: string;
    recentProjects: string;
    viewAll: string;
    noProjects: string;
    visits: string;
    conversions: string;
    conversionRate: string;
    activePages: string;
    quantumStatus: string;
  };
  subscription: {
    title: string;
    subtitle: string;
    adminActive: string;
    adminDesc: string;
    adminStatus: string;
    paySuccessTitle: string;
    paySuccessDesc: string;
    payFailureTitle: string;
    payFailureDesc: string;
    securePaymentTitle: string;
    securePaymentDesc: string;
    paymentNote: string;
    whyAffordableTitle: string;
    whyAffordableDesc: string;
    avgSavings: string;
    comparisonTitle: string;
    comparisonSubtitle: string;
    comparisonColFeature: string;
    trialTitle: string;
    trialDesc: string;
    trialBtnFree: string;
    trialBtnUsed: string;
    proDesc: string;
    scaleDesc: string;
    entDesc: string;
    month: string;
    membroFundador: string;
    vagasRestantes: string;
    vagasEsgotadas: string;
    prazoEncerrado: string;
    precoNovoAviso: string;
    vagasLimite: string;
    travePreco: string;
    detalhesMoeda: string;
    iofAviso: string;
  };
  general: {
    back: string;
    exit: string;
    save: string;
    saving: string;
    saved: string;
    loading: string;
    or: string;
    errorTitle: string;
    errorAction: string;
  };
}

export type SupportedLanguage = 'pt' | 'en' | 'es';

export const translations: Record<SupportedLanguage, TranslationSet> = {
  pt: {
    sidebar: {
      plataforma: "Plataforma",
      gestao: "Gestão",
      suporte: "Suporte",
      dashboard: "Dashboard",
      optimizer: "Otimizador Inteligente",
      copywriter: "Redator Publicitário IA",
      landing_pages: "Landing Pages",
      quantum: "Conector Quantum",
      integrations: "Integrações",
      reports: "Relatórios",
      networking: "Networking",
      subscription: "Assinatura",
      domain: "Domínio Customizado",
      settings: "Configurações",
      terms: "Termos de Uso",
      privacy: "Privacidade",
      guide: "Guia da Plataforma",
      contact: "Contato",
      system: "Sistema",
      synchronized: "Sincronizado",
      simulateClient: "Simular Cliente",
      clientActive: "Modo Cliente Ativo",
      freePlan: "Gratuito",
      trialPlan: "Teste Grátis",
      adminPlan: "Admin",
      daysRemaining: "d rest.",
      accessPremium: "Acesso Premium: Este recurso está disponível nos planos Scale e Enterprise.",
    },
    dashboard: {
      title: "Painel de Controle",
      subtitle: "Acompanhe e configure a conversão de seus funis inteligentes.",
      launchButton: "Lançar Novo Projeto",
      setupDomainButton: "Configurar Domínio",
      guideButton: "Guia de Escala",
      howItWorksButton: "COMO FUNCIONA O OPTIVELO?",
      recentProjects: "Projetos Recentes",
      viewAll: "Ver todos",
      noProjects: "Nenhum projeto lançado ainda.",
      visits: "Visitas Únicas",
      conversions: "Conversões",
      conversionRate: "Taxa de Conversão",
      activePages: "Páginas Ativas",
      quantumStatus: "Quantum Command Center",
    },
    subscription: {
      title: "Escolha seu Plano",
      subtitle: "Desbloqueie o poder total da IA e escale suas conversões com o OptiVelo.",
      adminActive: "Acesso de Administrador Ativo",
      adminDesc: "Como dono da plataforma, você tem acesso ilimitado a todas as ferramentas e recursos sem custo.",
      adminStatus: "Status: Ilimitado",
      paySuccessTitle: "Pagamento Recebido!",
      paySuccessDesc: "Sua assinatura está sendo processada e será liberada em instantes.",
      payFailureTitle: "Ops! Algo deu errado.",
      payFailureDesc: "Não conseguimos processar seu pagamento. Por favor, tente novamente.",
      securePaymentTitle: "Pagamento Seguro via Mercado Pago",
      securePaymentDesc: "Aceitamos Pix, Boleto e Cartão de Crédito em até 12x. Oferecemos 14 dias de garantia incondicional.",
      paymentNote: "Seu pagamento é processado de forma 100% segura. Não armazenamos seus dados de cartão.",
      whyAffordableTitle: "Por que o OptiVelo é mais acessível?",
      whyAffordableDesc: "Diferente de ferramentas globais que cobram em dólar (chegando a custar mais de R$ 550/mês), o OptiVelo oferece planos focados no mercado brasileiro, cobrando nacionalmente em Real sem IOF ou taxas de câmbio.",
      avgSavings: "Economia média de R$ 5.436,00 / ano em comparação com ferramentas globais",
      comparisonTitle: "Comparativo de Ferramentas",
      comparisonSubtitle: "Veja detalhadamente o que cada plano oferece para sua operação.",
      comparisonColFeature: "Funcionalidade",
      trialTitle: "14 Dias Grátis",
      trialDesc: "Experimente o poder total do OptiVelo sem compromisso por 14 dias.",
      trialBtnFree: "Começar Teste Grátis",
      trialBtnUsed: "Teste Utilizado",
      proDesc: "O melhor custo-benefício para profissionais e negócios em crescimento.",
      scaleDesc: "Para negócios que precisam de escala agressiva e ferramentas avançadas.",
      entDesc: "O ápice da IA Generativa Estratégica para grandes operações.",
      month: "/ mês",
      membroFundador: "Membro Fundador - Mais Popular",
      vagasRestantes: "Apenas {count} vagas restantes",
      vagasEsgotadas: "Vagas de Fundador Esgotadas",
      prazoEncerrado: "Oferta de Lançamento Encerrada",
      precoNovoAviso: "{price} mês (pós-lançamento)",
      vagasLimite: "Limite de 100 membros atingido",
      travePreco: "Garanta o preço de Fundador por 1 ano inteiro",
      detalhesMoeda: "Exibido em BRL (R$). Transação nacional sem cobrança de IOF ou taxas de câmbio internacionais.",
      iofAviso: "Fita Fiscal: Transação Direta Nacional (0% IOF Câmbio Incidente)",
    },
    general: {
      back: "Voltar",
      exit: "Sair",
      save: "Salvar Alterações",
      saving: "Salvando...",
      saved: "Alterações Salvas!",
      loading: "Carregando...",
      or: "ou",
      errorTitle: "Ops! Algo deu errado",
      errorAction: "Recarregar Aplicativo",
    }
  },
  en: {
    sidebar: {
      plataforma: "Platform",
      gestao: "Management",
      suporte: "Support",
      dashboard: "Dashboard",
      optimizer: "Smart Optimizer",
      copywriter: "Smart Copywriter IA",
      landing_pages: "Landing Pages",
      quantum: "Quantum Connector",
      integrations: "Integrations",
      reports: "Reports",
      networking: "Networking",
      subscription: "Subscription",
      domain: "Custom Domain",
      settings: "Settings",
      terms: "Terms of Use",
      privacy: "Privacy",
      guide: "Platform Guide",
      contact: "Contact Us",
      system: "System",
      synchronized: "Synchronized",
      simulateClient: "Simulate Client",
      clientActive: "Client Mode Active",
      freePlan: "Free",
      trialPlan: "Free Trial",
      adminPlan: "Admin",
      daysRemaining: "d left",
      accessPremium: "Premium Access: This feature is only available in the Scale and Enterprise plans.",
    },
    dashboard: {
      title: "Control Panel",
      subtitle: "Track and configure the conversion optimization of your smart funnels.",
      launchButton: "Launch New Project",
      setupDomainButton: "Setup Domain",
      guideButton: "Scale Guide",
      howItWorksButton: "HOW DOES OPTIVELO WORK?",
      recentProjects: "Recent Projects",
      viewAll: "View all",
      noProjects: "No projects launched yet.",
      visits: "Unique Visits",
      conversions: "Conversions",
      conversionRate: "Conversion Rate",
      activePages: "Active Pages",
      quantumStatus: "Quantum Command Center",
    },
    subscription: {
      title: "Choose Your Plan",
      subtitle: "Unleash the full power of AI and skyrocket your conversion rates with OptiVelo.",
      adminActive: "Active Administrator Access",
      adminDesc: "As platform owner, you have unlimited access to all tools and features at no cost.",
      adminStatus: "Status: Unlimited",
      paySuccessTitle: "Payment Received!",
      paySuccessDesc: "Your subscription is being processed and will be activated shortly.",
      payFailureTitle: "Oops! Something went wrong.",
      payFailureDesc: "We could not process your payment. Please try again.",
      securePaymentTitle: "Secure Payment via Mercado Pago",
      securePaymentDesc: "We accept Pix, Boleto, and Credit Cards up to 12x. 14-day unconditional money-back guarantee.",
      paymentNote: "Your payment is processed securely. We never store your credit card information.",
      whyAffordableTitle: "Why is OptiVelo more affordable?",
      whyAffordableDesc: "Unlike foreign platforms that bill in raw dollars, our system adapts locally. Enjoy cutting edge neural marketing tech with local currency flexibility, tax-efficiency, and fully compliant features.",
      avgSavings: "Average savings of $1,050.00 / year compared to standard global software suites",
      comparisonTitle: "Feature Comparison Matrix",
      comparisonSubtitle: "See in detail what each plan offers for your operations.",
      comparisonColFeature: "Feature set",
      trialTitle: "14 Days Free trial",
      trialDesc: "Experience the full capabilities of OptiVelo completely free of obligation.",
      trialBtnFree: "Start Free Trial",
      trialBtnUsed: "Trial Already Used",
      proDesc: "Best cost-benefit for scaling developers, freelancers and growing businesses.",
      scaleDesc: "For high-octane operations requiring deep analytics and extreme scale.",
      entDesc: "The pinnacle of Generative Strategic neural models for large-tier agencies.",
      month: "/ mo",
      membroFundador: "Founder Member - Best Deal",
      vagasRestantes: "Only {count} slots remaining",
      vagasEsgotadas: "Founder Slots Sold Out",
      prazoEncerrado: "Launch Promo Expired",
      precoNovoAviso: "{price}/mo (post-launch)",
      vagasLimite: "Limit of 100 pioneer slots reached",
      travePreco: "Lock your Pioneer Lifetime Rate for 12 full months",
      detalhesMoeda: "Converted to USD ($). International rate includes local taxes + 4.38% IOF standard tax already computed.",
      iofAviso: "Tax Report: Includes 4.38% Exchange Tax (IOF) + secure gateway conversion fees.",
    },
    general: {
      back: "Back",
      exit: "Exit",
      save: "Save Changes",
      saving: "Saving...",
      saved: "Changes Saved!",
      loading: "Loading...",
      or: "or",
      errorTitle: "Oops! Something went wrong",
      errorAction: "Reload Application",
    }
  },
  es: {
    sidebar: {
      plataforma: "Plataforma",
      gestao: "Gestión",
      suporte: "Soporte",
      dashboard: "Tablero",
      optimizer: "Optimizador Inteligente",
      copywriter: "Redactor Publicitario IA",
      landing_pages: "Páginas de Destino",
      quantum: "Conector Quantum",
      integrations: "Integraciones",
      reports: "Reportes",
      networking: "Networking",
      subscription: "Suscripción",
      domain: "Dominio Personalizado",
      settings: "Configuraciones",
      terms: "Términos de Uso",
      privacy: "Privacidad",
      guide: "Guía de Plataforma",
      contact: "Contacto",
      system: "Sistema",
      synchronized: "Sincronizado",
      simulateClient: "Simular Cliente",
      clientActive: "Modo Cliente Activo",
      freePlan: "Gratuito",
      trialPlan: "Prueba Gratis",
      adminPlan: "Admin",
      daysRemaining: "d rest.",
      accessPremium: "Acceso Premium: Este recurso está disponible en los planes Scale y Enterprise.",
    },
    dashboard: {
      title: "Tablero de Control",
      subtitle: "Supervise y ajuste la optimización de conversión de sus embudos inteligentes.",
      launchButton: "Lanzar Nuevo Proyecto",
      setupDomainButton: "Configurar Dominio",
      guideButton: "Guía de Escalabilidad",
      howItWorksButton: "¿CÓMO FUNCIONA OPTIVELO?",
      recentProjects: "Proyectos Recientes",
      viewAll: "Ver todos",
      noProjects: "Ningún proyecto lanzado aún.",
      visits: "Visitas Únicas",
      conversions: "Conversiones",
      conversionRate: "Tasa de Conversión",
      activePages: "Páginas Activas",
      quantumStatus: "Quantum Command Center",
    },
    subscription: {
      title: "Elija su Plan",
      subtitle: "Desbloquee el poder completo de la IA y escale sus conversiones con OptiVelo.",
      adminActive: "Acceso de Administrador Activo",
      adminDesc: "Como propietario de la plataforma, tiene acceso ilimitado a todas las herramientas y funciones sin costo.",
      adminStatus: "Estado: Ilimitado",
      paySuccessTitle: "¡Pago Recibido!",
      paySuccessDesc: "Su suscripción se está procesando y estará activa en unos momentos.",
      payFailureTitle: "¡Ups! Algo salió mal.",
      payFailureDesc: "No logramos procesar su pago. Por favor intente nuevamente.",
      securePaymentTitle: "Pago Seguro a través de Mercado Pago",
      securePaymentDesc: "Aceptamos Pix, Boleto y Tarjeta de Crédito en hasta 12 cuotas. 14 días de garantía incondicional.",
      paymentNote: "Su pago se procesa de forma segura. No almacenamos datos de su tarjeta de crédito.",
      whyAffordableTitle: "¿Por qué OptiVelo es más económico?",
      whyAffordableDesc: "A diferencia de las corporaciones globales de alto costo dolarizado, diseñamos OptiVelo para adaptarse localmente al mercado. Disfrute de inteligencia neural de alto rendimiento con precios transparentes.",
      avgSavings: "Ahorro promedio de €980.00 / año en comparación con suites corporativas globales",
      comparisonTitle: "Tabla Comparativa de Herramientas",
      comparisonSubtitle: "Observe a detalle lo que cada plan ofrece para sus operaciones de negocio.",
      comparisonColFeature: "Funcionalidad",
      trialTitle: "Prueba de 14 Días Gratis",
      trialDesc: "Pruebe todas las facultades de OptiVelo sin compromiso por 14 días.",
      trialBtnFree: "Iniciar Prueba Gratis",
      trialBtnUsed: "Prueba Ya Utilizada",
      proDesc: "La mejor relación costo-beneficio para profesionales y negocios en crecimiento.",
      scaleDesc: "Para operaciones comerciales medianas que demandan métricas profundas y escala agresiva.",
      entDesc: "La cumbre de la IA generativa estratégica de alto desempeño para grandes agencias.",
      month: "/ mes",
      membroFundador: "Miembro Fundador - El Más Popular",
      vagasRestantes: "Solo {count} vacantes disponibles",
      vagasEsgotadas: "Vacantes de Fundador Agotadas",
      prazoEncerrado: "Oferta de Lanzamiento Finalizada",
      precoNovoAviso: "{price} mes (post-lanzamiento)",
      vagasLimite: "Límite de 100 miembros pioneros alcanzado",
      travePreco: "Congele su tarifa de miembro fundador durante 12 meses completos",
      detalhesMoeda: "Mostrado en Euros (EUR €). Transacciones internacionales seguras con conversión local y 4.38% de impuesto IOF pre-calculado.",
      iofAviso: "Reporte Fiscal: Incluye cálculo de 4.38% de IOF + tasas de pasarelas internacionales de conversión de monedas.",
    },
    general: {
      back: "Regresar",
      exit: "Salir",
      save: "Guardar Cambios",
      saving: "Guardando...",
      saved: "¡Cambios Guardados!",
      loading: "Cargando...",
      or: "o",
      errorTitle: "¡Ups! Algo salió mal",
      errorAction: "Recargar Aplicación",
    }
  }
};
